/**
 *  StandardKeySequences is a module that defines standard key sequences of commonly created bindings
 *
 *  @copyright Copyright 2015 The MathWorks, Inc.
 */

define([
        // dojo
        "mw-keybindings/DefaultKeys"

    ],
    function (DefaultKeys ) {

        var standardKeySequences =
        {
            Cut:   [DefaultKeys.SYSCTRL,DefaultKeys.X],
            Copy:  [DefaultKeys.SYSCTRL,DefaultKeys.C],
            Paste: [DefaultKeys.SYSCTRL,DefaultKeys.V],
            Undo:  [DefaultKeys.SYSCTRL,DefaultKeys.Z],
            Redo:  [DefaultKeys.SYSCTRL,DefaultKeys.Y]
        }

        return standardKeySequences;
    });

